export default {
  solicitantes: 'Applicants',
  entidades: 'Entities',
  cuenta: 'Accounts',
  configuracion: 'Settings',
  usuarios: 'Users',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Trámites'
};



// WEBPACK FOOTER //
// ./src/common/lang/en/menu.js